module.exports = {"attachmentsFilesTitle":"Załączniki *","attachmentsFilesTitleDescription":"Dodaj pliki uprawodopodniające okoliczności zakupu towaru (np. paragon, faktura, itd.).","addFileButtonText":"Dodaj"}


//////////////////
// WEBPACK FOOTER
// ./src/components/File/translate.json
// module id = 604
// module chunks = 0